var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pop",staticClass:"popover-wrapper",class:{show: _vm.show},style:({display: _vm.display ?'block':'none'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }